import { Component } from '@angular/core';
import { AuthRepository } from '@timechef/core/auth';
import { AccountRepository } from '@timechef/features/account/state';
import { combineLatest, map } from 'rxjs';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
  standalone: false,
})
export class LogoComponent {
  marqueName: string | null = null;
  imgSrc$ = combineLatest([this.accountRepo.theme$, this.authRepo.currentSite$]).pipe(
    map(([theme, site]) => {
      if (theme === 'dark' && site?.specificLogoDarkUrl) {
        this.marqueName = null;
        return site.specificLogoDarkUrl;
      }
      if (theme === 'light' && site?.specificLogoLightUrl) {
        this.marqueName = null;
        return site.specificLogoLightUrl;
      }

      if (site) this.marqueName = site.marqueName;

      return `/assets/TC_logo_${theme}.svg`;
    }),
  );

  constructor(
    private accountRepo: AccountRepository,
    private authRepo: AuthRepository,
  ) {}
}
